import React, { useState, useEffect, useContext, useMemo } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { DefaultButton, PrimaryButton } from "@fluentui/react";
import { t } from "i18next";
import CustomBreadCrumb from "../../../components/CustomBreadCrumb";
import { TOAST_TYPE, ACTIONS } from "../../../constants/Constants";
import toastContext from "../../../context/toast/ToastContext";
import themeContext from "../../../context/theme/ThemeContext";
import userContext from "../../../context/users/UserContext";
import Select from "react-select";
import { constantStyleForSelect } from "../../../components/CustomSelect";
import { addAgenticTemplate, getFirmsList, getLLMAgentList, getTemplatesListByAgent, updateAgenticTemplate } from "../../../service/MasterService";
import loaderContext from "../../../context/loader/LoaderContext";
import "froala-editor/css/froala_style.min.css";
import "froala-editor/css/froala_editor.pkgd.min.css";
import FirmTemplateSection from "./FirmTemplateSection";
import { getEnv } from '../../../helpers/EnvHelper';

const customStyles = `
  .style-content-textarea {
    background-color: #ffffff !important;
    color: #000000 !important;
    width: 96.3% !important;
  }

  .style-content-textarea:focus {
    outline: none !important;
    box-shadow: none !important;
    border-color: inherit !important;
  }
`;

const AddTemplate = ({ action = ACTIONS.ADD }) => {
  const { agentId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { getThemeColor, getAlterColor } = useContext(themeContext);
  const { loadByUsername, authenticated } = useContext(userContext);
  const { showToastv2 } = useContext(toastContext);
  const { setLoaderRunning, ref } = useContext(loaderContext);
  const isEdit = action === ACTIONS.EDIT || location.pathname.includes("/edit/");
  const [isLoading, setIsLoading] = useState(true);
  const [llmAgentOptions, setLLMAgentOptions] = useState([]);
  const [clientOptions, setClientOptions] = useState([]);
  const [stylesData, setStylesData] = useState(null);
  const [selectedTemplate, setSelectedTemplate] = useState(null);;
  const [templateContent, setTemplateContent] = useState("");
  const [firmTemplateList, setFirmTemplateList] = useState([
    { firmIds: [], templateContent: "" } // <== NEW
  ]);

  
  console.log("llmAgentOptions ", llmAgentOptions);

  const [breadCrumbItems] = useState([
    {
      text: t("Agentic Report Template"),
      key: "my_templates",
      onClick: () => window.location.href = "/agentic/list/template/1",
    },
    {
      text: isEdit ? t("Edit Template") : t("Add New Template"),
      key: isEdit ? "edit_template" : "add_template",
    },
  ]);

  const handleFirmChange = (index, selectedFirmIds) => {
    const updated = [...firmTemplateList];
    updated[index].firmIds = selectedFirmIds; // <== updated field
    setFirmTemplateList(updated);
  };

  const handleTemplateChange = (index, content) => {
    const updated = [...firmTemplateList];
    updated[index].templateContent = content;
    setFirmTemplateList(updated);
  };

  const handleAddMore = () => {
    const lastEntry = firmTemplateList[firmTemplateList.length - 1];
    const hasClients = lastEntry.firmIds.length > 0;
    const hasTemplate = lastEntry.templateContent.trim().length > 0;

    if (hasClients && hasTemplate) {
      setFirmTemplateList([
        ...firmTemplateList,
        { firmIds: [], templateContent: "" }
      ]);
    } else {
      showToastv2(TOAST_TYPE.ERROR, "Please fill Client and Template before adding more.");
    }
  };


  const handleRemoveSection = (index) => {
    const updated = [...firmTemplateList];
    updated.splice(index, 1);
    setFirmTemplateList(updated);
  };

  const fetchFirmList = async () => {
    const response = await getFirmsList();
    let firmList = [];
    response?.data?.data?.map((firm) => {
    //   if (firm.id === values.firmId) {
    //     setSelectedFirmId({
    //       value: firm.id,
    //       label: firm.name,
    //     });
    //   }

      firmList.push({
        value: firm.id,
        label: firm.name,
      });
    });
    setClientOptions(firmList);
  };

  const fetchLLMAgentList = async () => {
    const response = await getLLMAgentList();
    let agentList = [];

    response?.data?.data?.forEach((agent) => {
      agentList.push({
        value: agent.id,
        label: agent.title,
      });
    });

    setLLMAgentOptions(agentList); // <-- useState for dropdown options
  };


  const config = {
    placeholderText: "Edit Your Content Here!",
    key: getEnv("REACT_APP_FROALA_API_KEY"),
    charCounterCount: false,
    attribution: false,
    height: "20vh",
    width: "100%",
    fontSize: [
      "8",
      "9",
      "10",
      "10.67",
      "11",
      "12",
      "13",
      "13.33",
      "14",
      "14.67",
      "15",
      "16",
      "17",
      "17.33",
      "18",
      "18.67",
      "19",
      "21.33",
      "24",
      "30",
      "36",
      "48",
      "60",
      "72",
      "96",
    ],
    fontSizeDefault: "12",
    fontSizeUnit: 'px',
    lineHeights: {
      Default: '1.5',
      Single: '1',
      '1.15': '1.15',
      '1.5': '1.5',
      Double: '2'
    },
    wordPasteModal: false,
    pluginsEnabled: [
      "fullscreen",
      "codeBeautifier",
      "colors",
      "fontFamily",
      "fontSize",
      "paragraphFormat",
      "paragraphStyle",
      "align",
      "lists",
      "table",
      "wordPaste"
    ],
    toolbarButtons: {
      moreText: {
        buttons: [
          "undo",
          "redo",
          "|",
          "paragraphFormat",
          "|",
          "fontFamily",
          "|",
          "fontSize",
          "|",
          "bold",
          "italic",
          "underline",
          "strikeThrough",
          "clearFormatting",
          "|",
          "textColor",
          "backgroundColor",
          "|",
          "alignLeft",
          "alignCenter",
          "alignRight",
          "alignJustify",
          // 'inlineClass',
          // 'inlineStyle',
          "formatOL",
          "formatUL",
          "outdent",
          "indent",
          "|",
          "insertTable",
          "|",
          "copy",
        ],
        align: "left",
        buttonsVisible: 10,
      },
    },
  };

  useEffect(() => {
    if (!authenticated) {
      loadByUsername();
    }
    fetchFirmList();
    fetchLLMAgentList();
    
  }, [authenticated]);

  useEffect(() => {
    fetchFirmList();
    fetchLLMAgentList();
    
  }, []);

  useEffect(() => {
  if (!isEdit || !agentId || llmAgentOptions.length === 0 || clientOptions.lenght === 0) return;
  const fetchData = async () => {
    setLoaderRunning(true);
    ref.current.continuousStart();
    try {
      const response = await getTemplatesListByAgent(agentId); 
      if (response.status === 200 && response.data.result === "SUCCESS") {
        const data = response.data.data; 

        setStylesData(data);
        
        if (isEdit && agentId) {

          console.log("llm data from if ", llmAgentOptions);

          const matchedOption = llmAgentOptions.find(option => option.value === parseInt(agentId));
          if (matchedOption) {
            setSelectedTemplate(matchedOption);
          }

          if (Array.isArray(data.agenticReportTemplate) && data.agenticReportTemplate.length > 0) {
            const firmTemplates = data.agenticReportTemplate.map(template => {
              const mappedFirmIds = (template.clientIdList || []).map(clientId => {
                const match = clientOptions.find(opt => opt.value === clientId);
                return match || { value: clientId, label: `Firm ${clientId}` };
              });

              return {
                firmIds: mappedFirmIds,
                templateContent: template.templateContent || ""
              };
            });

            setFirmTemplateList(firmTemplates);
          } else {
            setFirmTemplateList([]);
          }

          setTemplateContent(""); 
        }
      } else {
        showToastv2(TOAST_TYPE.ERROR, "Failed to fetch data");
        navigate("/agentic/list/template/1");
      }
    } catch (error) {
      showToastv2(TOAST_TYPE.ERROR, "Error fetching data");
      navigate("/agentic/list/template/1");
    } finally {
      setIsLoading(false);
      setLoaderRunning(false);
      ref.current.complete();
    }
  };

  fetchData();
}, [agentId, isEdit,llmAgentOptions,clientOptions]);

  useEffect(() => {
    if (!isEdit && llmAgentOptions.length) {
      setIsLoading(false);
    }
  }, [isEdit, llmAgentOptions]);


  useEffect(() => {
    if (isLoading) {
      setLoaderRunning(true);
      ref.current.continuousStart();
    } else {
      setLoaderRunning(false);
      ref.current.complete();
    }
    return () => {
      setLoaderRunning(false);
      ref.current.complete();
    };
  }, [isLoading]);

  const handleSubmit = async () => {
    if (!selectedTemplate) {
      showToastv2(TOAST_TYPE.ERROR, "Please select a report template");
      return;
    }

    if (firmTemplateList.length === 0) {
      showToastv2(TOAST_TYPE.ERROR, "Please add at least one template block");
      return;
    }

    // Check each template block
    for (let i = 0; i < firmTemplateList.length; i++) {
      const block = firmTemplateList[i];

      if (!block.templateContent?.trim()) {
        showToastv2(TOAST_TYPE.ERROR, `Please fill Template Content for block ${i + 1}`);
        return;
      }

      if (!block.firmIds || block.firmIds.length === 0) {
        showToastv2(TOAST_TYPE.ERROR, `Please assign at least one client to block ${i + 1}`);
        return;
      }
    }

    setLoaderRunning(true);
    ref.current.continuousStart();

    try {
      const agenticReportTemplate = firmTemplateList.map(item => ({
        templateContent: item.templateContent,
        clientIdList: item.firmIds.map(firm => firm.value),
      }));

      const payload = {
        agentId: selectedTemplate.value,
        agenticReportTemplate,
      };

      console.log("Submitting payload\n", JSON.stringify(payload, null, 2));

      const response = isEdit
        ? await updateAgenticTemplate(payload)
        : await addAgenticTemplate(payload);

      if (response?.data?.result === "SUCCESS" || [200, 201].includes(response?.status)) {
        showToastv2(
          TOAST_TYPE.SUCCESS,
          response.data?.message ?? (isEdit ? "Template updated successfully" : "Template created successfully")
        );
        setTimeout(() => (window.location.href = "/agentic/list/template/1"), 500);
      } else {
        showToastv2(
          TOAST_TYPE.ERROR,
          response.data?.message ?? `Failed to ${isEdit ? "update" : "add"} template`
        );
      }
    } catch (err) {
      console.error("Submission error", err);
      showToastv2(
        TOAST_TYPE.ERROR,
        err?.response?.data?.message ?? `Error ${isEdit ? "updating" : "adding"} template`
      );
    } finally {
      setLoaderRunning(false);
      ref.current.complete();
    }
  };



  if (isLoading) {
    return (
      <div className="main-container-body" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <div className="breadCrumb">
          <CustomBreadCrumb items={breadCrumbItems} />
        </div>
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '100%',
          backgroundColor: getAlterColor("background-color")
        }}>
        </div>
      </div>
    );
  }

  return (
    <div className="main-container-body" style={{ display: 'flex', flexDirection: 'column', height: '100%' , backgroundColor: getAlterColor("background-color")}}>
      <div className="breadCrumb">
        <CustomBreadCrumb items={breadCrumbItems} />
      </div>
      <div className="report-template-content modal-scroll" style={{ flex: 1, overflowY: 'auto', padding: '10px 20px'}}>
        <div className="report-template-form" style={{ width: "70%" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              backgroundColor: getAlterColor("background-color"),
              borderRadius: "4px",
            }}
          >
            <div style={{ width: "100%", padding: "10px 0px 0px 20px" }}>
              <section className="sectionA">
                <p style={{ fontSize: "20px", fontWeight: "600", marginLeft: "10px" }}>Style Details</p>
              </section>

              <div className="ms-Grid" dir="ltr" style={{ marginBottom: "14px" }}>
                <div className="ms-Grid-row">
                  <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
                    <div className="agentic-report-template-list-key">
                      Reporting Agents
                      <span style={{ marginLeft: "4px", color: "red", fontWeight: "bold" }}>*</span>
                    </div>
                    <Select
                      classNamePrefix="react-select"
                      options={llmAgentOptions}
                      value={selectedTemplate}
                      styles={constantStyleForSelect(getThemeColor)}
                      onChange={setSelectedTemplate}
                      isDisabled={isEdit}
                    />
                  </div>
                </div>
              </div>

                {firmTemplateList.map((entry, index) => {
                  // Collect all firmIds except current section
                  const disabledFirmIds = firmTemplateList
                    .filter((_, i) => i !== index)
                    .flatMap(f => f.firmIds.map(firm => firm.value));

                  return (
                    <React.Fragment key={index}>
                      <FirmTemplateSection
                        index={index}
                        firmOptions={clientOptions}
                        selectedFirms={entry.firmIds}
                        onFirmChange={handleFirmChange}
                        templateContent={entry.templateContent}
                        onTemplateChange={handleTemplateChange}
                        getThemeColor={getThemeColor}
                        config={config}
                        onRemove={handleRemoveSection}
                        showRemoveButton={firmTemplateList.length > 1}
                        disabledFirmIds={disabledFirmIds}
                      />
                      {index < firmTemplateList.length - 1 && (
                        <div
                          style={{
                            height: "1px",
                            backgroundColor: getThemeColor("border-color") || "#ccc",
                            margin: "24px 0",
                            opacity: 0.3,
                          }}
                        />
                      )}
                    </React.Fragment>
                  );
                })}

              <PrimaryButton
                text="Add More"
                onClick={handleAddMore}
                styles={{ root: { marginTop: "10px", borderRadius: "10px", marginLeft: "10px" } }}
              />


            </div>
          </div>
        </div>
      </div>
      <div 
        className="bottom-bar"
        style={{
          padding: '20px',
          display: 'flex',
          justifyContent: 'flex-start',
          gap: '10px',
          marginLeft: '30px',
          borderTop: `1px solid ${getThemeColor('border')}`
        }}
      >
        <DefaultButton
          text="Cancel"
          onClick={() => navigate("/agentic/list/template/1")}
          styles={{ root: { border: getThemeColor("border"), borderRadius: "7px" } }}
        />
        <PrimaryButton 
          text="Save"
          onClick={handleSubmit} 
          styles={{ root: { borderRadius: "7px" } }} 
        />
      </div>
      <style>{customStyles}</style>
    </div>
  );
};

export default AddTemplate;